<template>
  <div>
    <McInlineFilter
      :filterItems="inlineFilterItems"
      :activeKeys="activeFilters['status.name']"
      @update:activeKeys="handleChangeActiveFilters([{ key: 'status.name', values: $event }])"
    />
    <McTable
      v-show="isTableDataAvailable"
      withCard
      searchable
      stickyHeader
      :hasCheckbox="false"
      :hasSelectAll="false"
      :fields="fields"
      :apiClient="apiClient"
      :activeFilters="activeFilters"
      :customHandlers="customHandlers"
      @available-change="handleDataAvailable"
    >
      <template #[`cell(status.name)`]="{ value, item }">
        <span
          v-if="item.status?.color"
          class="__status-dots"
          :style="{ backgroundColor: item.status.color }"
        ></span>
        <span style="color: #344264">{{ value }}</span>
      </template>

      <template #[`cell(contract_type)`]="{ value }">
        <span
          v-if="value && CONTRACT_TYPE?.[value]?.name"
        >{{ CONTRACT_TYPE[value].name }}</span>
        <template v-else>-</template>
      </template>

      <template #[`cell(reference.number)`]="{ value, item }">
        <a
          class="text-primary"
          :href="$router.resolve({
            name: 'Master Customer Contract Detail',
            params: {
              contractId: item.reference.id,
            },
          }).href" 
          target="_blank"
        >
          {{ value }}
        </a>
      </template>

      <template #[`cell(effective_date)`]="{ value }">
        <template v-if="value">
          <div>{{ formatIndexDate(value).date }}</div>
        </template>
        <template v-else>-</template>
      </template>

      <template #[`cell(expired_date)`]="{ value }">
        <template v-if="value">
          <div>{{ formatIndexDate(value).date }}</div>
        </template>
        <template v-else>-</template>
      </template>

      <template #[`cell(public_tracking_url)`]="{ item }">
        <McButton
          variant="secondary"
          text="Bagikan"
          icon="icon-fill_share"
          size="sm"
          :disabled="disabledTrackLink(item)"
          :displayTooltip="false"
          @click="handleTrackLink(item)"
        />
      </template>
    </McTable>

    <b-card v-show="!isTableDataAvailable">
      <div class="empty-table-container">
        <img src="@/assets/images/no-data-illustration.png" alt />
        <strong>Belum ada data Kontrak Customer</strong>
        <p>Tambahkan data terlebih dulu ya!</p>
        <McButton 
          variant="primary"
          :text="$t('global.addField')"
          icon="icon-outline_plus"
          @click="handleAdd"
        />
      </div>
    </b-card>

    <ShareTrackModal :detailData="dataTrackLink" />
  </div>
</template>
<script>
import McInlineFilter from '@/components/McInlineFilter'
import McTable from '@/components/McTable'
import McButton from '@/components/McButton'
import ShareTrackModal from './components/ShareTrackModal'

import inlineFilterItems from './lib/constants/inline-filter-items'
import filterMappings from './lib/constants/filter-mappings'
import { CONTRACT_TYPE } from './lib/constants/contract_type'

import fields from './lib/fields/list-table-fields'

import transformFilter from '@/helpers/resourceful/transform-filter'
import { formatIndexDate } from '@/helpers/tzDate'

import * as Contract from '@/services/rest-api/lib/contract/customer-contract'

export default {
  components: {
    McInlineFilter,
    McTable,
    McButton,
    ShareTrackModal,
  },
  data() {
    return {
      fields,
      inlineFilterItems,
      CONTRACT_TYPE,

      activeFilters: {},
      isTableDataAvailable: true,
      dataTrackLink: null,
    }
  },
  computed: {
    apiClient() {
      let getContract = Contract.get
      if (Object.keys(this.activeFilters).length > 0) {
        let filters = transformFilter(filterMappings, this.activeFilters)
        getContract = Contract.getWithFilters(filters)
      }
  
      return {
        get: getContract,
      }
    },
    customHandlers() {
      return {
        handleClickRow: this.handleClickRow,
        handleAdd: this.handleAdd,
        handleOpenNewTab: this.handleOpenNewTab,
      }
    },
  },
  methods: {
    formatIndexDate,
    /**
     * @typedef {Object} Filter
     * @property {String} key
     * @property {String} values
     *
     * @param {Filter[]} filters
     */
    handleChangeActiveFilters(filters) {
      this.isTableDataAvailable = true
      for (const filter of filters) {
        this.$delete(this.activeFilters, filter.key)

        if (filter.values == null) continue
        if (Array.isArray(filter.values) && filter.values.length === 0) continue

        this.$set(this.activeFilters, filter.key, filter.values)
      }
    },
    handleDataAvailable(isAvailable) {
      this.isTableDataAvailable = isAvailable
    },
    handleClickRow(item) {
      this.$router.push({
        name: 'Master Customer Contract Detail',
        params: {
          contractId: item.id,
        },
      })
    },
    handleOpenNewTab(item) {
      const query = this.$route.query

      return this.$router.resolve({ name: 'Master Customer Contract Detail', params: { contractId: item.id }, query })
        .href
    },
    handleAdd() {
      this.$router.push({ name: 'Master Customer Contract Create' })
    },
    disabledTrackLink(item) {
      if (item?.public_tracking_url && item?.total_vehicle > 0) {
        return false
      }

      return true
    },
    handleTrackLink(item) {
      this.dataTrackLink = item
      this.$bvModal.show('modal-link')
    },
  }
}
</script>
<style lang="scss" scoped>
.__status-dots {
  display: inline-block;
  margin: auto;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 8px;
}
</style>